<template>
    <div class="video-box" :class="videoClass">
        <video ref="video" v-bind="$attrs" v-on="$listeners"></video>
    </div>
</template>

<script>
export default {
    name: 'defaultVideo',
    props: {
        muted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            videoClass: ''
        };
    },
    mounted() {
        this.$video = this.$refs.video;
        this.toggleMuted(this.muted);

        if (!this.playOnPop) {
            this.videoClass = 'is-contain';
        }

        this.$emit('canplay');
    },
    methods: {
        calcVideoStyle(option) {
            let { autoHeight, ratio, playOnPop } = option;

            let videoRatio = this.$video.videoHeight / this.$video.videoWidth;
            if (
                (autoHeight &&
                    this.$attrs.playsinline &&
                    !this.$attrs.autoplay) ||
                (!playOnPop && ratio < videoRatio) ||
                (playOnPop && ratio > videoRatio)
            ) {
                this.videoClass = 'auto-height';
            } else {
                this.videoClass = 'auto-width';
            }

            return videoRatio;
        },
        playVideo() {
            this.$video.play();
        },
        toggleMuted(muted) {
            this.$video.muted = muted;
        },
        pauseVideo() {
            this.$video.pause();
        }
    }
};
</script>

<style lang="scss" scoped>
.video-box {
    width: 100%;
    height: 100%;
    video {
        width: 100%;
        height: 100%;
    }
}
.auto-height {
    width: 100%;
    height: auto;
    video {
        width: 100%;
        height: auto;
        display: block;
    }
}
.auto-width {
    width: auto;
    height: 100%;
    video {
        width: auto;
        max-width: 100%;
        height: 100%;
    }
}
</style>
